//-------------------------- verification  -------------------------- //

window.stepCheck = {}

stepCheck.stepAmount = async function (stepSelected, with_error, with_target) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'notes_amount') {
        const notes_amount = stepElement.querySelector('#notes_amount')

        if (notes_amount.value < 1) {
            error = true

            toggleInputError(notes_amount, stepElement, false, with_error)
        } else {
            toggleInputError(notes_amount, stepElement, true, with_error)
        }
    }

    return error
}

stepCheck.stepContact = async function (stepSelected, with_error, with_target) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'first_name') {
        const first_name = stepElement.querySelector('#first_name')

        if (first_name.value.length < 2 || isAlphaString(first_name.value) === false) {
            error = true

            toggleInputError(first_name, stepElement, false, with_error)
        } else {
            toggleInputError(first_name, stepElement, true, with_error)
        }
    }

    if (with_target == null || with_target === 'last_name') {
        const last_name = stepElement.querySelector('#last_name')

        if (last_name.value.length === 0 || isAlphaString(last_name.value) === false) {
            error = true

            toggleInputError(last_name, stepElement, false, with_error)
        } else {
            toggleInputError(last_name, stepElement, true, with_error)
        }
    }

    return error
}

stepCheck.stepAddress = function (stepSelected, with_error) {
    const stepElement = steps[stepSelected]
    let error = false

    const address = stepElement.querySelector('#address')

    if (address.value.length === 0) {
        error = true
    } else {
        if (hasAddressDetails() === false) {
            error = true
        }
    }

    toggleInputError(address, stepElement, !error, with_error)

    return error
}

stepCheck.stepEmailPhone = async function (stepSelected, with_error, with_target, is_step_handle) {
    const stepElement = steps[stepSelected]
    let error = false

    if (with_target == null || with_target === 'phone') {
        const phone = stepElement.querySelector('#phone')

        if (isPhone(phone.value) === false) {
            error = true

            toggleInputError(phone, stepElement, false, with_error)
        } else {
            if (is_step_handle === true) { //do phone verification only when button is clicked
                toggleLoading(phone, true)

                let is_valid = await twilioVerify(phone.value)

                toggleLoading(phone, false)

                if (is_valid === true) {
                    toggleInputError(phone, stepElement, true, with_error)
                } else {
                    error = true

                    toggleInputError(phone, stepElement, false, with_error)
                }
            } else {
                toggleInputError(phone, stepElement, true, with_error)
            }
        }
    }

    if (with_target == null || with_target === 'email_address') {
        const email_address = stepElement.querySelector('#email_address')

        if (isEmailAddress(email_address.value) === false) {
            error = true

            toggleInputError(email_address, stepElement, false, with_error)
        } else {
            toggleInputError(email_address, stepElement, true, with_error)
        }
    }

    return error
}

//-------------------------- binds  -------------------------- //

window.setupBind = {}

setupBind.stepInit = function (stepElement, stepKey) {
    const inputNotesReason = stepElement.querySelector('#notes_reason');
    const boxReasons = stepElement.querySelectorAll('.box-reason-list .box-reason');
    const BOX_NOT_SURE_ID = 'box-reason-im-not-sure';
    const DEFAULT_STROKE = '#616161';
    const SELECTED_STROKE = '#ffffff';

    function setValueForInputNotesReason() {
        const selectedBoxes = stepElement.querySelectorAll('.box-reason-list .box-reason.selected');
        const values = Array.from(selectedBoxes).map(box =>
            box.querySelector('.box-reason-text')?.textContent.trim()
        );
        inputNotesReason.value = values.join(', ');
    }

    function resetSelection(clickedBox) {
        const isNotSureBox = clickedBox.id === BOX_NOT_SURE_ID;

        const selectedBoxes = stepElement.querySelectorAll('.box-reason-list .box-reason');

        selectedBoxes.forEach(box => {
            box.classList.remove('selected');
            const path = box.querySelector('svg path');
            path?.setAttribute('stroke', DEFAULT_STROKE);
        });
    }

    boxReasons.forEach(box => {
        box.addEventListener('click', () => {
            resetSelection(box);

            const isSelected = box.classList.toggle('selected');

            const path = box.querySelector('svg path');

            if (path) {
                path.setAttribute('stroke', isSelected ? SELECTED_STROKE : DEFAULT_STROKE);
            }

            setValueForInputNotesReason();
        });
    });
};


setupBind.stepInit = function (stepElement, stepKey) {
    function setValueForInputNotesReason() {
        const inputNotesReason = stepElement.querySelector('#notes_reason');
        const boxReasons = stepElement.querySelectorAll('.box-reason-list .box-reason.selected');
        const valueList = [];

        boxReasons.forEach(box => {
            valueList.push(box.querySelector('.box-reason-text').textContent.trim());
        });

        inputNotesReason.value = valueList.join(', ')
    }

    function resetSelection(box) {
        if (box.id === 'box-reason-im-not-sure') {
            const boxReasons = stepElement.querySelectorAll('.box-reason-list .box-reason.selected');

            console.log(boxReasons);
            console.log('reset')

            boxReasons.forEach(box => {
                box.classList.remove('selected');

                const path = box.querySelector('svg path');

                path.setAttribute('stroke', '#616161');
            });
        } else {
            const boxNotSure = stepElement.querySelector('#box-reason-im-not-sure');

            boxNotSure.classList.remove('selected');
            boxNotSure.querySelector('svg path').setAttribute('stroke', '#616161');
        }
    }

    const boxReasons = stepElement.querySelectorAll('.box-reason-list .box-reason');

    boxReasons.forEach(box => box.addEventListener('click', async () => {
        resetSelection(box);

        box.classList.toggle('selected');

        const path = box.querySelector('svg path');
        const strokeColor = path.getAttribute('stroke');

        if (strokeColor === '#616161') {
            path.setAttribute('stroke', '#ffffff');
        } else {
            path.setAttribute('stroke', '#616161');
        }

        setValueForInputNotesReason();
    }))
}

setupBind.stepAmount = function (stepElement, stepKey) {
    const slider = stepElement.querySelector('#amountRangeSelector');
    const notesAmount = document.querySelector('#notes_amount');

    function formatWithCommas(value) {
        return Number(value).toLocaleString('en-US');
    }

    function parseFormatted(value) {
        return value.replace(/,/g, '');
    }

    // When slider moves, update number input (with formatting)
    slider.addEventListener('input', function () {
        let rawValue = Math.round(this.value / 1000) * 1000;

        this.value = rawValue;

        notesAmount.value = formatWithCommas(rawValue);
    });

    //  While typing, just keep raw digits (no formatting yet)
    notesAmount.addEventListener('input', function () {
        const rawValue = parseFormatted(this.value);

        if (!/^\d*$/.test(rawValue)) {
            return;
        }

        slider.value = rawValue;
    });

    // When focus leaves input, format it
    notesAmount.addEventListener('blur', function () {
        let rawValue = parseFormatted(this.value);

        if (rawValue) {
            let roundedValue = Math.round(rawValue / 1000) * 1000;

            slider.value = roundedValue;

            this.value = formatWithCommas(roundedValue);
        } else {
            this.value = '';
        }
    });

    // Optional: set initial sync on page load
    notesAmount.value = formatWithCommas(slider.value);
}

setupBind.stepCoverage = function (stepElement, stepKey) {
    const stepSelected = getStepKeyByID(stepElement.id)
    const options = stepElement.querySelectorAll('input[type="radio"][name="notes[coverage]"]')

    options.forEach(radio => radio.addEventListener('click', async () => {
        await stepHandle(stepSelected)
    }))
}

setupBind.stepHealth = function (stepElement, stepKey) {
    const stepSelected = getStepKeyByID(stepElement.id)
    const options = stepElement.querySelectorAll('input[type="radio"][name="notes[health]"]')

    options.forEach(radio => radio.addEventListener('click', async () => {
        await stepHandle(stepSelected)
    }))
}

setupBind.stepTiming = function (stepElement, stepKey) {
    const stepSelected = getStepKeyByID(stepElement.id)
    const options = stepElement.querySelectorAll('input[type="radio"][name="notes[timing]"]')

    options.forEach(radio => radio.addEventListener('click', async () => {
        await stepHandle(stepSelected)
    }))
}

setupBind.stepContact = function (stepElement, stepKey) {
    let idsContact = ['first_name', 'last_name']

    //first_name
    let inputFirstName = stepElement.querySelector('#first_name')

    inputFirstName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepContact(stepKey, false, 'first_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputFirstName.addEventListener('change', () => {
        stepCheck.stepContact(stepKey, false, 'first_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    //last_name
    let inputLastName = stepElement.querySelector('#last_name')

    inputLastName.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepContact(stepKey, false, 'last_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputLastName.addEventListener('change', () => {
        stepCheck.stepContact(stepKey, false, 'last_name')

        let is_disabled = stepInputValid(idsContact) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

setupBind.stepAddress = function (stepElement, stepKey) {
    let inputAddress = stepElement.querySelector('#address')

    inputAddress.addEventListener('keydown', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        resetAddressComponent()

        let is_disabled = stepCheck.stepAddress(stepKey, false)

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputAddress.addEventListener('change', () => {
        let is_disabled = stepCheck.stepAddress(stepKey, false)

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

setupBind.stepEmailPhone = function (stepElement, stepKey) {
    let idsEmailPhone = ['phone', 'email_address']

    //phone
    let inputPhoneHome = stepElement.querySelector('#phone')

    inputPhoneHome.addEventListener('keydown', async (event) => {
        if (!upKeyCodePhone(event)) {
            event.preventDefault()
        }
    })

    inputPhoneHome.addEventListener('keyup', async (event) => {
        if (formatKeyCodePhone(event)) {
            formatToPhone(event)

            await stepCheck.stepEmailPhone(stepKey, false, 'phone')

            let is_disabled = stepInputValid(idsEmailPhone) !== true

            stepNextButtonStatus(stepKey, is_disabled)
        }
    })

    inputPhoneHome.addEventListener('change', async (event) => {
        formatToPhone(event)

        await stepCheck.stepEmailPhone(stepKey, false, 'phone')

        let is_disabled = stepInputValid(idsEmailPhone) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    //email
    let inputEmailAddress = stepElement.querySelector('#email_address')

    inputEmailAddress.addEventListener('keyup', (event) => {
        if (keyCodeIgnore(event) === true) {
            return
        }

        stepCheck.stepEmailPhone(stepKey, false, 'email_address')

        let is_disabled = stepInputValid(idsEmailPhone) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })

    inputEmailAddress.addEventListener('change', () => {
        stepCheck.stepEmailPhone(stepKey, false, 'email_address')

        let is_disabled = stepInputValid(idsEmailPhone) !== true

        stepNextButtonStatus(stepKey, is_disabled)
    })
}

//-------------------------- form  -------------------------- //

stepShowRules = function (stepSelected) {
    return stepSelected
}

stepShowSetup = function (stepSelected) {
    //show tcpa info
    if (steps[stepSelected].id === options.stepFinal) {
        document.querySelector('.tcpa-info').style.display = 'block'
    } else {
        document.querySelector('.tcpa-info').style.display = 'none'
    }

    //hide elements depending on form step
    if (steps[stepSelected].id !== options.stepFirst) {
        toggleElementsBasedOnFormStep(true)
    }

    let formContentElement = document.querySelector('#form-container .form-content')

    formContentElement.className = 'box form-content'
    formContentElement.classList.add(steps[stepSelected].id)
}

toggleElementsBasedOnFormStep = function(is_hidden) {
    const hideElements = document.querySelectorAll('.form-hide')

    for (const hideElement of hideElements) {
        if (is_hidden === true) {
            hideElement.classList.add('hidden-on')
        } else {
            hideElement.classList.remove('hidden-on')
        }
    }
}

stepNextButtonAppend = function(stepElement, p) {
    stepElement.appendChild(p)
}

submitHandle = function (button) {
    const form = button.form
    const formData = new FormData(form)

    window.history.pushState({}, null, options.resultsURL)

    toggleElementsBasedOnFormStep(false) //add header & footer elements back

    stepNextButtonLoading(button, false) //this actually disable overlay

    if (typeof options.submitCallback !== 'undefined' && typeof options.submitCallback === 'function') {
        options.submitCallback(formData)
    }

    fetch(options.processURL, {
        method: 'POST',
        credentials: 'same-origin',
        body: formData,
        mode: 'cors',
        headers: {
            'Access-Control-Allow-Origin': '*',
        }
    })

    if (mdrvConfigData.environment === 'production') {
        googleTriggerEvent('LeadFormSubmit')
    }
}
